<setup-node [allowEdit]="true" [editing]="editing()" [displayTemplate]="displayTemplate" [editTemplate]="editTemplate">
  <ng-template #displayTemplate>
    <app-svg-icon
      *ngIf="phase().milestones?.length > 0"
      icon="chevron-down"
      [strokeWidth]="2"
      color="var(--color-grey-900)"
      class="expand-icon"
      [class.expanded]="expanded()"
      (click)="toggleExpanded()"
    ></app-svg-icon>
    <span class="phase-name">{{ phase().title }}</span>
  </ng-template>
  <ng-template #editTemplate>
    <div class="edit-container">
      <dx-form
        class="gpd-form"
        [formData]="phase()"
        [colCount]="5"
        width="100%"
        (onFieldDataChanged)="onDataChanged($event)"
        [showColonAfterLabel]="false"
      >
        <dxi-form-item
          dataField="title"
          caption="Name"
          i18n-text="@@name"
          [editorOptions]="{
            valueChangeEvent: 'input',
            validationMessageMode: 'always',
          }"
          cssClass="gpd-input"
          [colSpan]="3"
        >
          <dx-text-box
            class="gpd-input"
            [(value)]="phase().title"
            valueChangeEvent="input"
            [maxLength]="50"
            validationMessageMode="always"
          >
            <dx-validator>
              <dxi-validation-rule type="required" i18n-message="@@required" message="Required" />
              <dxi-validation-rule
                type="custom"
                [reevaluate]="true"
                [validationCallback]="uniqueNameValidationCallback"
                i18n-message="@@nameAlreadyExists"
                message="Name already Exists."
              />
            </dx-validator>
          </dx-text-box>
        </dxi-form-item>
        <dxi-form-item
          dataField="showInGantt"
          [label]="{ visible: false }"
          editorType="dxCheckBox"
          [colSpan]="2"
          [editorOptions]="{
            text: messageShowInGantt,
            valueChangeEvent: 'input',
            validationMessageMode: 'always',
          }"
          cssClass="gpd-input show-in-gantt-checkbox"
          horizontalAlignment="right"
          verticalAlignment="center"
        >
          <dxi-validation-rule type="required" i18n-message="@@required" message="Required"></dxi-validation-rule>
        </dxi-form-item>
      </dx-form>
      <div class="gpd-button-group">
        <app-svg-icon
          id="help-icon-{{ phase().id }}"
          icon="help"
          color="var(--color-grey-900)"
          class="help-icon"
          [size]="16"
        >
        </app-svg-icon>
        <dx-popover
          target="#help-icon-{{ phase().id }}"
          showEvent="mouseenter"
          hideEvent="mouseleave"
          [wrapperAttr]="{ class: 'gpd-popover' }"
          position="bottom"
          style="display: none"
        >
          <div class="help-context" i18n="@@phaseHelp">
            When activated, this phase will be displayed in the project schedule.
          </div>
        </dx-popover>
        <app-svg-icon
          *ngIf="allowDelete()"
          icon="delete"
          [size]="24"
          color="var(--color-red-500)"
          class="gpd-button-icon"
          (click)="onDeleteClicked()"
        ></app-svg-icon>
      </div>
    </div>
    <dx-validator [adapter]="adapterConfig">
      <dxi-validation-rule
        type="custom"
        [validationCallback]="validationCallback"
        i18n-message="@@phaseConfigInvalidValidationMessage"
        message="Phase configuration is invalid"
        style="display: none"
      ></dxi-validation-rule>
    </dx-validator>
  </ng-template>
</setup-node>

